import commentYt from '@src/components/comment-yt-icon/comment-yt-icon.component'
import videoViewsYt from '@src/components/video-views-icon/video-views-icon.component'

const icons = {
  like: 'fa-solid fa-heart',
  likes: 'fa-solid fa-heart',
  comment: 'fa-solid fa-comment',
  commentYt,
  comments: 'fa-solid fa-comment',
  video: 'fa-regular fa-video',
  stories: 'fa-solid fa-film',
  post: 'fa-solid fa-image-polaroid',
  tweet: 'fa-solid fa-comment-dots',
  retweet: 'fa-solid fa-retweet',
  tweetThread: 'fa-solid fa-messages',
  startDate: 'fa-regular fa-calendar-day',
  endDate: 'fa-regular fa-calendar-check',
  week: 'fa-regular fa-calendar-week',
  generalRanking: 'fa-solid fa-ranking-star',
  scoreRanking: 'fa-solid fa-tachometer-alt',
  referralRanking: 'fa-solid fa-th-large',
  money: 'fa-regular fa-sack-dollar',
  cash: 'fa-regular fa-sack-dollar',
  products: 'fa-regular fa-bag-shopping',
  product: 'fa-regular fa-bag-shopping',
  performance: 'fa-light fa-chart-line',
  vouchers: 'fa-regular fa-ticket',
  kit: 'fa-regular fa-box',
  time: 'fa-regular fa-clock',
  save: 'fa-solid fa-bookmark',
  saves: 'fa-solid fa-bookmark',
  reels: 'fa-solid fa-tv-retro',
  view: 'fa-solid fa-eye',
  views: 'fa-solid fa-eye',
  share: 'fa-solid fa-share',
  shares: 'fa-solid fa-share',
  gamification: 'fa-solid fa-trophy',
  reply: 'fa-solid fa-reply',
  tap_back: 'fa-solid fa-hand-back-point-left',
  tap_forward: 'fa-solid fa-hand-back-point-right',
  videoViews: 'fa-regular fa-circle-play',
  videoViewsYt,
  videoLike: 'fa-solid fa-thumbs-up',
  videoDislike: 'fa-solid fa-thumbs-down',
  fileContract: 'fa-solid fa-file-contract',
}

export default icons
